/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { TextField, CountryField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { Form } from '@organisms';
import { Block, ErrorMessage } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';

import { FORM_FIELD } from './constants';

// hardcoded for uat
const logos = {
  youtube: { id: '64076177c03a2d6ea6502479', fileName: '64076173c03a2d6ea6502478.png' },
  facebook: { id: '6407624b1b34cbafe9f684c5', fileName: '640762471b34cbafe9f684c4.png' },
};

const BroadcasterForm = ({ initialValues = {}, error, form }) => {
  const [mediaDisabled, setMediaDisabled] = React.useState(false);
  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <Form.WithFieldValue name={FORM_FIELD.NAME.name}>
          {(value) => {
            const val = value?.toLowerCase().trim();
            console.log(value);
            if (val === 'youtube' || val === 'facebook') {
              setMediaDisabled(true);
              form.setFieldsValue({
                [FORM_FIELD.LOGO.name]: logos[val],
              });
            } else setMediaDisabled(false);
          }}
        </Form.WithFieldValue>
        <TextField {...FORM_FIELD.NAME} />
        <TextField {...FORM_FIELD.URL} />
        {!mediaDisabled ? (
          <MediaField {...FORM_FIELD.LOGO} skipCrop />
        ) : (
          <TextField {...FORM_FIELD.LOGO} style={{ display: 'none' }} />
        )}

        <CountryField
          rules={[{ required: true, message: 'Country is required' }]}
          wrapperCol={{ span: 24 }}
          style={NO_MARGIN_BOTTOM}
          name="countryName"
          label="Country:"
          extra={null}
        />
      </Block>
    </Form>
  );
};

BroadcasterForm.useForm = () => Form.useForm(FORM_FIELD);

export default BroadcasterForm;
